// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfl_a big_bk big_bl big_bo","SwipeLeftToClose--animating":"bfl_b"};